import { BroadcastChannel } from 'broadcast-channel'

// We must use this library as old versions of safari doesn't support BroadcastChannel API
export const broadcastChannel = new BroadcastChannel('sync-tabs')
